<script lang="ts" setup>
import { useImage } from '@/shared/composables/image'
import { EventBaseCard } from '@/shared/ui/cards'
import { IEventPreview } from '@/enitites/event/model/types'
import { getDateFormatted } from '@/services/date'

const { getImageById } = useImage()
defineProps<{
  previewEvent: IEventPreview
}>()
</script>

<template>
  <router-link
    :to="{ name: 'Event', params: { id: previewEvent.id } }"
    class="event-card-mobile"
  >
    <EventBaseCard>
      <template #img>
        <v-img
          :src="getImageById(previewEvent.image, 800, 800, 'event')"
          alt=""
          class="img"
        />
      </template>
      <template #title>
        <h5 class="event-card-title">
          {{ previewEvent.title }}
        </h5>
      </template>
      <template #date>
        <p class="event-card-date">
          {{ getDateFormatted(previewEvent.dateStart) }}
        </p>
      </template>
    </EventBaseCard>
  </router-link>
</template>
